import React, {useContext, useState} from "react"
import {useFormikContext} from "formik"
import {useRouter} from "next/router"
import CheckoutContext from "../../context/CheckoutContext"

const LanguageButtons = () => {
	const formik = useFormikContext()
	const router = useRouter()
	const {data} = useContext(CheckoutContext)
	const {locale} = router
	const [selectedDE, setSelectedDE] = useState(data.contact?.language_selected ? data?.contact.language_selected === "DE" : locale === "de")
	const [selectedFR, setSelectedFR] = useState(data.contact?.language_selected ? data?.contact.language_selected === "FR" : locale === "fr")
	const [selectedENG, setSelectedENG] = useState(data.contact?.language_selected ? data?.contact.language_selected === "ENG" : false)
	const [selectedITA, setSelectedITA] = useState(data.contact?.language_selected ? data?.contact.language_selected === "ITA" : false)
	const [selectedPOR, setSelectedPOR] = useState(data.contact?.language_selected ? data?.contact.language_selected === "POR" : false)

	return (
		<div className="row ">
			<div className={"col-auto mb-3"}>
				<button
					onClick={() => {
						formik.setFieldValue("language_selected", "DE")
						setSelectedDE(true)
						setSelectedFR(false)
						setSelectedENG(false)
						setSelectedITA(false)
						setSelectedPOR(false)
					}}
					type={"button"}
					className={`btn px-4  text-start overflow-hidden position-relative ${selectedDE ? "text-white bg-dark" : "text-dark bg-light"}`}
					style={{borderRadius: "16px"}}
				>
					{"Deutsch"}
				</button>
			</div>

			<div className={"col-auto mb-3"}>
				<button
					onClick={() => {
						formik.setFieldValue("language_selected", "FR")
						setSelectedDE(false)
						setSelectedFR(true)
						setSelectedENG(false)
						setSelectedITA(false)
						setSelectedPOR(false)
					}}
					type={"button"}
					className={`btn px-4  text-start overflow-hidden position-relative ${selectedFR ? "text-white bg-dark" : "text-dark bg-light"}`}
					style={{borderRadius: "16px"}}
				>
					{"Français"}
				</button>
			</div>

			<div className={"col-auto mb-3"}>
				<button
					onClick={() => {
						formik.setFieldValue("language_selected", "ENG")
						setSelectedDE(false)
						setSelectedFR(false)
						setSelectedENG(true)
						setSelectedITA(false)
						setSelectedPOR(false)
					}}
					type={"button"}
					className={`btn px-4  text-start overflow-hidden position-relative ${selectedENG ? "text-white bg-dark" : "text-dark bg-light"}`}
					style={{borderRadius: "16px"}}
				>
					{"English"}
				</button>
			</div>

			<div className={"col-auto mb-3"}>
				<button
					onClick={() => {
						formik.setFieldValue("language_selected", "ITA")
						setSelectedDE(false)
						setSelectedFR(false)
						setSelectedENG(false)
						setSelectedITA(true)
						setSelectedPOR(false)
					}}
					type={"button"}
					className={`btn px-4  text-start overflow-hidden position-relative ${selectedITA ? "text-white bg-dark" : "text-dark bg-light"}`}
					style={{borderRadius: "16px"}}
				>
					{"Italiano"}
				</button>
			</div>

			<div className={"col-auto mb-3"}>
				<button
					onClick={() => {
						formik.setFieldValue("language_selected", "POR")
						setSelectedDE(false)
						setSelectedFR(false)
						setSelectedENG(false)
						setSelectedITA(false)
						setSelectedPOR(true)
					}}
					type={"button"}
					className={`btn px-4  text-start overflow-hidden position-relative ${selectedPOR ? "text-white bg-dark" : "text-dark bg-light"}`}
					style={{borderRadius: "16px"}}
				>
					{"Português"}
				</button>
			</div>
		</div>

	)
}

export default LanguageButtons
